import { withAsyncLoading } from '../../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableCompagnonCreatePage = withAsyncLoading(async () =>
    import('./CompagnonCreatePage').then((res) => res.CompagnonCreatePage)
);

export { LoadableCompagnonCreatePage };
